import { ExternalLink, Phone, Mail, MessageSquare, Globe } from "lucide-react";
import { VerificationBadge } from "./Badges";
import { AUDIENCES, SUPPORT_TYPES } from "@/lib/site";

const contactIcon = (href = "") =>
  href.startsWith("tel:") ? Phone : href.startsWith("mailto:") ? Mail : href.startsWith("sms:") ? MessageSquare : Globe;

export const ServiceCard = ({ entry, compact = false }) => (
  <article className="card-soft p-6 md:p-7 flex flex-col gap-4 h-full" data-testid={`service-card-${entry.slug}`}>
    <div className="flex flex-wrap items-start justify-between gap-3">
      <h3 className="text-xl font-semibold leading-snug">{entry.name}</h3>
      <VerificationBadge entry={entry} />
    </div>
    <p className="text-ink-soft text-[0.98rem]">{entry.description}</p>
    {!compact && (
      <dl className="grid gap-2 text-sm">
        <div><dt className="inline font-semibold">Who they help: </dt><dd className="inline text-ink-soft">{entry.audiences.map((a) => AUDIENCES[a] || a).join(", ")}</dd></div>
        <div><dt className="inline font-semibold">Type of support: </dt><dd className="inline text-ink-soft">{entry.support_types.map((t) => SUPPORT_TYPES[t] || t).join(", ")}</dd></div>
        <div><dt className="inline font-semibold">Coverage: </dt><dd className="inline text-ink-soft">{entry.coverage}</dd></div>
        {entry.availability && <div><dt className="inline font-semibold">Availability: </dt><dd className="inline text-ink-soft">{entry.availability}</dd></div>}
      </dl>
    )}
    <div className="mt-auto flex flex-wrap gap-2 pt-2">
      {entry.contacts.map((c) => {
        const Icon = contactIcon(c.href);
        return (
          <a key={c.href} href={c.href} {...(c.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})} className="inline-flex items-center gap-2 rounded-full bg-teal-light px-4 py-2 min-h-[44px] text-sm font-semibold text-teal hover:bg-teal hover:text-cream transition-colors" data-testid={`service-contact-${entry.slug}-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <Icon className="h-4 w-4" aria-hidden="true" />{c.label}: {c.value}
          </a>
        );
      })}
      {entry.website && (
        <a href={entry.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-4 py-2 min-h-[44px] text-sm font-semibold hover:bg-cream-deep transition-colors" data-testid={`service-website-${entry.slug}`}>
          Visit website <ExternalLink className="h-4 w-4" aria-hidden="true" /><span className="sr-only">(opens in a new tab)</span>
        </a>
      )}
    </div>
  </article>
);
